import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-637d992d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_collapse = _resolveComponent("image-collapse")!
  const _component_collapse_comp = _resolveComponent("collapse-comp")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_component_collapse_comp, {
      key: _ctx.Index,
      Title: 'Click To Expand Image Editing',
      StartMinimized: true
    }, {
      default: _withCtx(() => [
        (this.displayData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.dataObj.ImageData, (ImageDatas, Index) => {
                return (_openBlock(), _createBlock(_component_image_collapse, {
                  key: Index,
                  Title: 'View More',
                  StartMinimized: true,
                  ImgData: ImageDatas,
                  onRemoveTag: _ctx.removeTag,
                  onRemoveThis: _ctx.RemoveImageDataItme
                }, null, 8, ["ImgData", "onRemoveTag", "onRemoveThis"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ]))
}